// Inspired by: https://web.archive.org/web/20241009143126/https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript
export function asError(unknownError: unknown): Error {
  if (unknownError instanceof Error) {
    return unknownError
  }
  const options = { cause: unknownError }
  if (
    typeof unknownError === "object" &&
    unknownError !== null &&
    "message" in unknownError &&
    typeof unknownError.message === "string"
  ) {
    return new Error(unknownError.message, options)
  }
  return new Error("Unknown error.", options)
}
